export function replaceDotsWithHyphens(name: string) {
  return name.replace(/\./g, '-');
}
